import { Link } from 'react-router-dom';
import { useSortable } from '@dnd-kit/sortable';
import IconArrow from '../../components/icons/IconArrow';
import IconDelete from '../../components/icons/IconDelete';
import IconGrip from '../../components/icons/IconGrip';
import { makeDndId } from '../../components/dnd/dndId';
import * as api from './api';

const TOPIC_EXERCISE_BASE = '/api/topicexercisetemplates';

// A linked exercise, rendered as just another card in the topic's own
// content flow (see TopicElementList.jsx's header comment for why this
// replaced the old separate "always at the bottom" LinkedExercisesPanel).
// Draggable for reordering among top-level siblings, but never
// containerizable - TopicExerciseTemplate has no `container` FK on the
// backend at all, so this card's drag handle only ever participates in the
// top-level SortableContext, never a container's own nested one (enforced
// in TopicElementList.jsx's handleDragOver, not here). No inline editor -
// unlike a block, there's nothing here to edit in place; the name links
// straight to that exercise's own Builder page.
export default function TopicExerciseCard({ courseId, link, canMoveUp, canMoveDown, onMove, onDeleted }) {
   const { attributes, listeners, setNodeRef, isDragging } = useSortable({ id: makeDndId('exerciseLink', link.id) });

   const handleDelete = () => {
      if (!window.confirm('Відв’язати цю вправу від теми?')) return;
      api.deleteOne(TOPIC_EXERCISE_BASE, link.id).then(() => onDeleted()).catch((err) => console.error(err));
   };

   return (
      <div ref={setNodeRef} className={'exercise-block-card' + (isDragging ? ' exercise-block-card-dragging' : '')} style={{ '--accent': '#e0b04c' }}>
         <div className='exercise-block-card-toolbar'>
            <div className='exercise-block-drag-handle' {...attributes} {...listeners}>
               <IconGrip style={{ width: 12, height: 12 }} />
               <span className='exercise-block-card-type-label'>Вправа</span>
            </div>
            <div className='exercise-block-card-actions'>
               <div className={'exercise-block-move-btn' + (!canMoveUp ? ' disabled' : '')} onClick={() => canMoveUp && onMove(-1)} title='Вгору'>
                  <IconArrow style={{ transform: 'rotate(-90deg)', height: 14, width: 14 }} />
               </div>
               <div className={'exercise-block-move-btn' + (!canMoveDown ? ' disabled' : '')} onClick={() => canMoveDown && onMove(1)} title='Вниз'>
                  <IconArrow style={{ transform: 'rotate(90deg)', height: 14, width: 14 }} />
               </div>
               <div className='exercise-block-delete-btn' onClick={handleDelete} title='Відвʼязати'>
                  <IconDelete style={{ fill: '#e0876c', width: 14, height: 14, margin: 0 }} />
               </div>
            </div>
         </div>
         <div className='exercise-block-card-body'>
            <Link className='topic-exercise-name' to={'/exercise-templates/' + (link.exerciseTemplate ? link.exerciseTemplate.id : '')}
               state={{ returnTo: '/courses/' + courseId }}>
               {link.exerciseTemplate ? link.exerciseTemplate.name : '—'}
            </Link>
            {link.exerciseTemplate && link.exerciseTemplate.level ? (
               <span className='topic-exercise-badge'>{link.exerciseTemplate.level.name}</span>
            ) : ''}
         </div>
      </div>
   );
}
